export const SET_CATEGORIES = 'setCategories';
export const SET_SELECTED_CATEGORY = 'setSelectedCategory';
export const TRY_FETCH_CATEGORIES = "tryFetchCategories";
